import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary'

// Clear chunk-load retry flag on successful app mount
// eslint-disable-next-line react-refresh/only-export-components
function Root() {
  useEffect(() => {
    sessionStorage.removeItem("chunk-load-retry");
  }, []);

  return (
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
}

createRoot(document.getElementById('root')!).render(<Root />)
